var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-slide-y-transition',{attrs:{"mode":"out-in"}},[(_vm.type === 'doughnut')?_c('doughnut-chart',{style:({
      height: _vm.height
    }),attrs:{"chart-data":_vm.chartData,"options":_vm.options}}):_vm._e(),_vm._v(" "),(_vm.type === 'bar')?_c('bar-chart',{style:({
      height: _vm.height
    }),attrs:{"chart-data":_vm.chartData,"options":_vm.options}}):_vm._e(),_vm._v(" "),(_vm.type === 'horizontal-bar')?_c('horizontal-bar-chart',{style:({
      height: _vm.height
    }),attrs:{"chart-data":_vm.chartData,"options":_vm.options}}):_vm._e(),_vm._v(" "),(_vm.type === 'pie')?_c('pie-chart',{style:({
      height: _vm.height
    }),attrs:{"chart-data":_vm.chartData,"options":_vm.options}}):_vm._e(),_vm._v(" "),(_vm.type === 'line')?_c('line-chart',{style:({
      height: _vm.height
    }),attrs:{"chart-data":_vm.chartData,"options":_vm.options}}):_vm._e(),_vm._v(" "),(_vm.type === 'polar-area')?_c('polar-area-chart',{style:({
      height: _vm.height
    }),attrs:{"chart-data":_vm.chartData,"options":_vm.options}}):_vm._e(),_vm._v(" "),(_vm.type === 'bubble')?_c('bubble-chart',{style:({
      height: _vm.height
    }),attrs:{"chart-data":_vm.chartData,"options":_vm.options}}):_vm._e(),_vm._v(" "),(_vm.type === 'radar')?_c('radar-chart',{style:({
      height: _vm.height
    }),attrs:{"chart-data":_vm.chartData,"options":_vm.options}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8ebfbf5c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/vue-chart/vue-chart.vue
// module id = 849
// module chunks = 9